module.exports = __webpack_public_path__ + "img/1f609.9f29075.svg";